import React from 'react';
import styles from './Hero.module.scss';

const academyPages = [
    '/academy',
    '/academy/',
    '/academy/interest',
    '/academy/interest/',
    '/academy/tuition',
    '/academy/tuition/',
    '/academy/experience',
    '/academy/experience/'
]
const Hero = (props) => (
  <div className={`page-hero ${styles.Hero}${academyPages.includes(props.location) || props.admissionsTemplate ? ' academy' : ''}`}>
    <div className={styles.Hero__Wrapper}>
      <div className={styles.Hero__Info}>
        <div className={academyPages.includes(props.location) || props.admissionsTemplate ? styles.Hero__Title__Academy : styles.Hero__Title}>
          <h1 dangerouslySetInnerHTML={{ __html: props.title }} />
        </div>
        <div className="iframe-wrap">
            <iframe src="https://www.youtube.com/embed/X2e2Sa9y54Y?rel=0" frameBorder="0" allowFullScreen></iframe>
        </div>
        <p>{props.description}</p>
      </div>
    </div>
  </div>
)

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Destination/Hero/VideoHero.js